import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getClientTypes() {
  const data = await apiGet('helper/clientTypes/');
  useHelperStore().setClientTypes(data);
}
